import script from "./ComplementedText.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplementedText.vue?vue&type=script&setup=true&lang=js"

import "./ComplementedText.vue?vue&type=style&index=0&id=d70e7df6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d70e7df6"]])

export default __exports__